import "../vendor/checkbox.min.js";
import FuiModuleModifier from "./fui-module";

export default class FuiCheckboxModifier extends FuiModuleModifier {
  override semanticModuleName = "checkbox";
}
